export default __webpack_public_path__ + "static/media/total-cholesterol.61e216c1.svg";